import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => {
  return {
    group: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    item: {
      marginRight: 50,
    },
  }
})
